module.exports = __webpack_public_path__ + "media/images/pokerroom/888/step2-pict02-44c083047cf5bdd99f6e13bd5c8f3f34.jpg";